import { auth, db } from '../config/firebase';
import {
  collection,
  addDoc,
  serverTimestamp,
  query,
  where,
  getDocs,
} from 'firebase/firestore';

export const submitReview = async ({
  reviewedUserId,
  requestId,
  rating,
  comment,
  role,
}) => {
  const currentUser = auth.currentUser;
  if (!currentUser) {
    throw new Error('Please log in to submit a review.');
  }

  if (!reviewedUserId) {
    throw new Error('User to review is missing.');
  }

  if (!requestId) {
    throw new Error('Request information is missing.');
  }

  if (!rating || rating < 1 || rating > 5) {
    throw new Error('Please select a rating between 1 and 5 stars.');
  }

  const reviewerName =
    currentUser.displayName ||
    currentUser.email?.split('@')[0] ||
    'FlexySwap user';

  const reviewsRef = collection(db, 'users', reviewedUserId, 'reviews');

  await addDoc(reviewsRef, {
    reviewerId: currentUser.uid,
    reviewerName,
    reviewedUserId,
    requestId,
    rating: Number(rating),
    comment: comment?.trim() || '',
    role,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  });

  return { success: true };
};

export const hasExistingReview = async (
  reviewedUserId,
  requestId,
  reviewerId,
) => {
  if (!reviewedUserId || !requestId || !reviewerId) {
    return false;
  }

  const reviewsRef = collection(db, 'users', reviewedUserId, 'reviews');
  const reviewQuery = query(
    reviewsRef,
    where('requestId', '==', requestId),
    where('reviewerId', '==', reviewerId),
  );
  const snapshot = await getDocs(reviewQuery);
  return !snapshot.empty;
};

